import {
    QueryFunction,
    QueryKey, 
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
    CommanDropdownResponse,
    DropdownCommanParams,
} from 'features/events/api/events-api.service';
import { NotificationApiService } from 'features/notification/api/notification-api.service';

import { NotificationQueryKeys } from './query-keys';
// useInfiniteQuery,
    //UseInfiniteQueryOptions,

const { getNotificationCommonDropDownList} = NotificationApiService();

const getDropDownQuery = (
    params: DropdownCommanParams,
    options?: UseQueryOptions<CommanDropdownResponse>,
): {
    queryKey: QueryKey;
    queryFn: QueryFunction<CommanDropdownResponse>;
    options?: UseQueryOptions<CommanDropdownResponse>;
} => ({
    queryKey: NotificationQueryKeys.list(params),
    queryFn: ({ signal }) => getNotificationCommonDropDownList(params, { config: { signal } }),
    ...options,
});


export const useGetDropDownData = (
    params: DropdownCommanParams,
    options?: UseQueryOptions<CommanDropdownResponse>,
) => {
    const { message } = App.useApp();

    return useQuery<CommanDropdownResponse, Error>(
          getDropDownQuery(params, {
            onError: (error: unknown) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            ...options,
        }),
    );
};

